import { useRef, type ComponentPropsWithoutRef } from 'react'
import { cn } from '@/lib/utils'
import { useAssistantPanelWidth } from './useAssistantPanelWidth'

export function AssistantAside({ resizable = false, className, children, ...props }: ComponentPropsWithoutRef<'aside'> & { resizable?: boolean }) {
  const ref = useRef<HTMLElement | null>(null)
  const { width, resizing, handleProps } = useAssistantPanelWidth(ref)

  return (
    <aside
      ref={ref}
      data-assistant
      {...props}
      style={width != null ? { width } : undefined}
      className={cn(
        'relative hidden h-full shrink-0 py-2 pr-2 max-xl:fixed max-xl:inset-y-0 max-xl:right-0 max-xl:z-40 md:flex',
        width == null && 'w-[400px] xl:w-[420px]',
        resizing && 'select-none',
        className
      )}
    >
      {resizable && (
        <div
          {...handleProps}
          data-resizing={resizing || undefined}
          className="group absolute inset-y-2 -left-1.5 z-10 flex w-3 cursor-col-resize touch-none items-center justify-center focus-visible:outline-none"
        >
          <span
            aria-hidden
            className="h-full w-0.5 rounded-full transition-colors group-hover:bg-primary/40 group-focus-visible:bg-primary group-data-[resizing]:bg-primary"
          />
          <span
            aria-hidden
            className="absolute top-1/2 h-9 w-1 -translate-y-1/2 rounded-full bg-border transition-colors group-hover:bg-primary group-focus-visible:bg-primary group-data-[resizing]:bg-primary"
          />
        </div>
      )}
      {children}
    </aside>
  )
}
